import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Link as ScrollLink } from 'react-scroll';
import classNames from 'classnames';
import _ from 'lodash';
import { getContentBlackout, isBlackoutError } from 'helpers/auth.blackout';
import { getLocationCookies, getSpoofedLocationCookies } from 'helpers/GeoLocationHelper';
import VideoPlayer from 'components/VideoPlayer';
import { withAuth } from 'index/AuthProvider';
import {
  getDesignatedMarketingAreaData,
  getPreviewPassLengthFromName,
  getPreviewPassTime,
  getMVPDExpireTime,
  previewPassLogout,
  PREVIEW_PASS_60,
  isGoogleHoldAccount,
  isRokuHoldAccount,
} from 'helpers/AuthHelper';
import { setEmailSubmissionSFMC } from 'index/AppActions';
import {
  emailCaptureEnabled,
  isEpgv2Enabled,
  previewPassEnabled,
  tveEnabled,
} from 'helpers/ConfigHelper';
import { noop } from 'helpers/GlobalHelper';
import { LIVE_PLAYER_BACKGROUND_IMAGE, renderImage } from 'helpers/ImageHelper';
import {
  getPlayerJs,
  getChannelBackgroundUrl,
  playerPause,
  playerRemove,
  playerPlay,
  getDuration,
  getContentPosition,
  getPlayerState,
  isPreviewPass,
  PLAYER_REFERENCE_DEFAULT,
  LIVE,
  PLAYER_STATES,
  VOD,
} from 'helpers/PlayerHelper';
import Loader from 'components/Loader';
import {
  getPreviewPassAnalyticsEvents,
  getSegmentLastAnonymousProfileId,
  getSegmentLastKnownProfileId,
  getSegmentMVPDEvents,
  getTealiumPlayerEvents,
  getSegmentOptimizelyString,
  sortEntitlements,
  TrackEvents as GeneralTrackEvents,
  handleAnalytics,
  Events,
} from '@foxcorp/delta-web-analytics';
import {
  isTabletBreakpoint,
  isMobileBreakpoint,
  SITE_PLATFORM_MOBILE,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_WEB_LARGE,
} from 'helpers/BreakpointHelper';
import {
  canDisplayUpsell,
  FNC,
  getAdDebug,
  getAdSiteSection,
  getEmailCaptureCookie,
  getMVPDFromCookie,
  getPrivacyParameterCookie,
  getRequiresAuth,
  getUrlParameter,
  isClip,
  isEpisode,
  isMovie,
  isMvpdSubscription,
  isSpecial,
  isStaticRender,
  setEmailCaptureCookie,
} from 'helpers/ContentHelper';
import { getMVPDCookie } from 'index/AuthHelper';
import { differenceInSeconds, msToDate, now } from 'helpers/DateTimeHelper';
import {
  getOptimizelyPlayerExperiments,
  getOptimizelyPreviewPassExperiments,
  getOptimizelyRedesignExperiments,
} from 'helpers/OptimizelyHelper';
import { determineBrowser } from 'components/Header/HeaderHelpers';
import Style from 'themes/styleguide/nation/Auth/Shared.module.scss';
import MessageStyle from './Overlays/ContextualRoadBlock/Styles/Message.module.scss';
import Message from './Overlays/ContextualRoadBlock/components/Message';
import {
  AdBlock,
  AreYouWatching,
  ContentBlackout,
  ContextualRoadBlock,
  EmailCapture,
  ExpiredVod,
  OnHoldAccount,
  OnPauseAccount,
} from './Overlays';
import Timer from './Timer';
import MVPDTimer from './MVPDTimer';
import { getChannelId } from './VideoContainerHelper';

const BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: {
    showLoader: true,
  },
  [SITE_PLATFORM_WEB]: {
    showLoader: true,
  },
  [SITE_PLATFORM_TABLET]: {
    showLoader: false,
  },
  [SITE_PLATFORM_MOBILE]: {
    showLoader: false,
  },
};

class VideoContainer extends Component {
  constructor(props) {
    super(props);
    const {
      account,
      anonymousAccount,
      background,
      isFreemium,
      isLive,
      isUngatedVideo,
      isVodUnavailable,
      mediaInfo,
      preauthorizedResources,
      requiresAuth,
      subscription,
      subscriptionPaused,
      videoId,
    } = props;
    const { emailCaptureExcludeVideoId } = window.ExternalConfig;
    const isExcludedEmailCapture = emailCaptureExcludeVideoId?.includes(videoId);
    const isSignedIn = account || isMvpdSubscription();
    const videoType = mediaInfo?.videoType;
    const isAccountOnHold = isGoogleHoldAccount(subscription);
    const isRokuOnHold = !isLive && isRokuHoldAccount(subscription);
    const isFreeLongFormVideo =
      isUngatedVideo && (isEpisode(videoType) || isMovie(videoType) || isSpecial(videoType));
    const preventPlayback =
      (anonymousAccount && !account && !isFreemium && !isMvpdSubscription() && !isUngatedVideo) ||
      (emailCaptureEnabled() &&
        isFreeLongFormVideo &&
        !getEmailCaptureCookie() &&
        !isSignedIn &&
        !isExcludedEmailCapture) ||
      (subscriptionPaused && !isUngatedVideo) ||
      isAccountOnHold ||
      isRokuOnHold;
    const displayUpsell = !isFreemium && canDisplayUpsell(preauthorizedResources);
    const showBuythroughUpsell =
      (!isStaticRender() && requiresAuth && displayUpsell) || preventPlayback;

    this.state = {
      activeVideo: null,
      checkedContentBlackout: false,
      delayPlayback: false,
      emailCaptureInput: '',
      hbaStatus: null,
      isAccountOnHold,
      isEmailCaptureValid: false,
      isPlayerLoaded: false,
      isRokuOnHold,
      isSubscriptionPaused: subscriptionPaused && !isUngatedVideo,
      isTrailerUpsell: false,
      mvpdExpired: false,
      percentWatched: 0,
      playerLoadingImage: background,
      playerState: null,
      previewPassExpired: false,
      previewPassSignIn: false,
      showBuythroughUpsell,
      showContentBlackout: false,
      showCookiesBlocked: false,
      showEmailCapture: isFreeLongFormVideo && !isExcludedEmailCapture,
      showExpiredVOD: isVodUnavailable,
      showProviders: false,
      showSearchProviders: false,
      showSignIn: true,
      spoofedGeolation: null,
      token: null,
      upstreamUserID: null,
    };

    this.isExcludedEmailCapture = isExcludedEmailCapture;
    this.previewPassLogout = previewPassLogout.bind(this);
    window.aeErrorHandling = this.accessEnablerAdvancedErrorHandler;
  }

  componentDidMount() {
    const { setBlockMVPDIncomplete, isUngatedVideo } = this.props;
    const { showBuythroughUpsell } = this.state;
    const spoofedGeolation = getSpoofedLocationCookies();
    if (showBuythroughUpsell) setBlockMVPDIncomplete(true);
    if (getUrlParameter('ec') === 'true' && !!isUngatedVideo && emailCaptureEnabled()) {
      setEmailCaptureCookie({ value: true, options: { path: '/' } });
      this.setState({ showEmailCapture: false, showBuythroughUpsell: false });
    }
    this.setState({ spoofedGeolation });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { account, isFreemium, isVodUnavailable, showTrailerUpsell, videoId } = this.props;
    const {
      background,
      isVodUnavailable: nextisVodUnavailable,
      mediaInfo: nextMediaInfo,
      requiresAuth: nextRequiresAuth,
      showTrailerUpsell: nextShowTrailerUpsell,
      videoId: nextVideoId,
      isUngatedVideo: nextIsUngatedVideo,
    } = nextProps;
    const videoType = nextMediaInfo?.videoType;
    const isFreeLongFormVideo =
      nextIsUngatedVideo && (isEpisode(videoType) || isMovie(videoType) || isSpecial(videoType));
    const isSignedIn = account || isMvpdSubscription();

    const nextState = {};

    if (nextShowTrailerUpsell !== showTrailerUpsell) {
      if (nextShowTrailerUpsell || !nextRequiresAuth) {
        nextState.showBuythroughUpsell = !isFreemium && nextShowTrailerUpsell;
      }
      nextState.isTrailerUpsell = nextShowTrailerUpsell;
    }
    if (nextVideoId && nextVideoId !== videoId) {
      nextState.playerLoadingImage = background;
    }
    if (nextisVodUnavailable !== isVodUnavailable) {
      nextState.showExpiredVOD = nextisVodUnavailable;
    }
    if (emailCaptureEnabled() && !this.isExcludedEmailCapture) {
      if (!isFreeLongFormVideo && nextIsUngatedVideo && isClip(videoType)) {
        nextState.showEmailCapture = false;
        nextState.showBuythroughUpsell = false;
      } else if (isFreeLongFormVideo && !getEmailCaptureCookie() && !isSignedIn) {
        nextState.showEmailCapture = true;
        nextState.showBuythroughUpsell = true;
      }
    }

    if (!_.isEmpty(nextState)) {
      this.setState(nextState);
    }
  }

  shouldComponentUpdate(nextProps) {
    const { guid, liveNow, waitToRenderPlayer } = this.props;
    const {
      guid: nextGuid,
      liveNow: nextLiveNow,
      mode: nextMode,
      waitToRenderPlayer: nextWaitToRenderPlayer,
    } = nextProps;
    // Block Video Container From Re-rendering when Live status changes
    if (
      nextMode === LIVE &&
      guid === nextGuid &&
      liveNow !== nextLiveNow &&
      waitToRenderPlayer === nextWaitToRenderPlayer
    ) {
      return false;
    }
    return true;
  }

  componentDidUpdate(lastProps, lastState) {
    const { isPlayerLoaded: previousIsPlayerLoaded } = lastState;
    const { isPlayerLoaded, checkedContentBlackout, showContentBlackout } = this.state;
    const {
      isUngatedVideo: prevIsUngatedVideo,
      preauthorizedResources: prevPreauthorizedResources,
      reducerVideo: prevReducerVideo,
      requiresAuth: prevRequiresAuth,
      requiresAuthLive: prevRequiresAuthLive,
      subscriptionPaused: prevSubscriptionPaused,
    } = lastProps;
    const {
      authSuccess,
      isFreemium,
      isLive,
      isUngatedVideo,
      preauthorizedResources,
      reducerVideo,
      requiresAuth,
      requiresAuthLive,
      setBlockMVPDIncomplete,
      setIsPlayerLoaded,
      subscriptionPaused,
    } = this.props;
    if (isPlayerLoaded !== previousIsPlayerLoaded) setIsPlayerLoaded(isPlayerLoaded);

    const reducerVideoId = _.get(reducerVideo, 'id');
    const prevReducerVideoId = _.get(prevReducerVideo, 'id');
    const reducerVideoChanged =
      prevReducerVideoId && reducerVideoId && reducerVideoId !== prevReducerVideoId;
    const reducerVideoInitialized = !prevReducerVideoId && reducerVideoId;
    const recheckBlackout = reducerVideoChanged && authSuccess;
    const checkInitialBlackout = !checkedContentBlackout && reducerVideoInitialized && authSuccess;

    const requiresAuthChanged = prevRequiresAuth !== requiresAuth;
    const requiresAuthLiveChanged = prevRequiresAuthLive !== requiresAuthLive;
    const contentGateChanged = isLive ? requiresAuthLiveChanged : requiresAuthChanged;
    const authorizedResourcesChanged = preauthorizedResources !== prevPreauthorizedResources;
    const subscriptionPausedChanged = subscriptionPaused !== prevSubscriptionPaused;
    const isUngatedVideoChanged = prevIsUngatedVideo !== isUngatedVideo;
    if (authorizedResourcesChanged || contentGateChanged) {
      const showUpsell = !isFreemium && canDisplayUpsell(preauthorizedResources);
      const showBuythroughUpsell = (requiresAuth && showUpsell) || subscriptionPaused;
      this.setState({ showBuythroughUpsell });
      setBlockMVPDIncomplete(showBuythroughUpsell);
    }
    if (reducerVideoChanged && showContentBlackout) this.setState({ showContentBlackout: false });
    if (checkInitialBlackout || recheckBlackout) {
      this.setState({ checkedContentBlackout: true });
      this.checkContentBlackout();
    }
    if (isUngatedVideoChanged) {
      this.setState({ isSubscriptionPaused: subscriptionPaused && !isUngatedVideo });
    }
    if (subscriptionPausedChanged && !isUngatedVideo) {
      this.setState({ isSubscriptionPaused: subscriptionPaused });
    }
  }

  componentWillUnmount() {
    const { setIsPlayerLoaded } = this.props;
    setIsPlayerLoaded(false);
  }

  onShowProvidersCallback = ({ show, keepVideoPaused = true } = {}) => {
    const { playerReference } = this.props;
    this.setState({ showProviders: show, previewPassSignIn: false }, () => {
      const { playerState } = this.state;
      const validStates = [PLAYER_STATES.PLAYING, PLAYER_STATES.AD, PLAYER_STATES.BUFFERING];
      const playVideo = _.indexOf(validStates, playerState) >= 0 && !keepVideoPaused;
      if (playVideo) playerPlay(playerReference);
    });
  };

  onShowSearchProvidersCallback = () => {
    const { showSearchProviders } = this.state;
    this.setState({
      showSearchProviders: !showSearchProviders,
    });
  };

  onEmailCaptureChange = event => {
    const emailCaptureInput = event.target.value;
    const isEmailRegexValid = /^\S+@\S+\.\S+$/gm.test(emailCaptureInput);
    const isEmailCaptureValid = event.target?.validity?.valid && isEmailRegexValid;
    this.setState({ emailCaptureInput, isEmailCaptureValid });
  };

  onEmailCaptureSubmit = async () => {
    const { accessToken, anonymousAccount, deviceId } = this.props;
    const { emailCaptureInput } = this.state;
    setEmailCaptureCookie({ value: true, options: { path: '/' } });
    const url = window?.location?.href;
    await setEmailSubmissionSFMC({
      url,
      email: emailCaptureInput.trim(),
      accessToken: accessToken || anonymousAccount?.accessToken,
      deviceId,
      platform: 'freevideostart_web_en-US',
      cb: () => {
        this.setState({ showEmailCapture: false, showBuythroughUpsell: false });
      },
    });
  };

  getPercentWatched = () => {
    const { playerReference } = this.props;
    const duration = getDuration(playerReference);
    const position = getContentPosition(playerReference);
    const percentWatched = (position / duration) * 100;

    return percentWatched;
  };

  setDelayPlayback = value => this.setState({ delayPlayback: value });

  setIsPlayerLoaded = player => {
    this.setState({ isPlayerLoaded: !!player });
  };

  setToken = ({ token, upstreamUserID, hbaStatus } = {}) => {
    this.setState({ token, upstreamUserID, hbaStatus });
  };

  accessEnablerAdvancedErrorHandler = err => {
    const errorId = _.get(err, 'errorId');
    const browser = determineBrowser();
    const isSafari = browser === 'safari';
    const cookiesDisabled = errorId === 'N130';
    const shouldShowCookiesBlocked = cookiesDisabled && isSafari;
    if (shouldShowCookiesBlocked) {
      this.setState({ showCookiesBlocked: true });
    }
  };

  checkContentBlackout = async () => {
    const {
      blackoutConfig,
      blackoutDefinitions,
      deviceId,
      dma,
      isLive,
      mvpd,
      network,
      setAuthError,
      reducerVideo,
    } = this.props;
    this.setState({ checkedContentBlackout: true });
    try {
      const cableProviderId = mvpd?.metadata?.mvpd;
      const zipCode = mvpd?.metadata?.zip?.[0];
      const contentRequiresAuth = getRequiresAuth({ video: reducerVideo });
      const blackoutOptions = {
        blackoutConfig,
        blackoutDefinitions,
        cableProviderId,
        contentRequiresAuth,
        deviceId,
        dma,
        getDesignatedMarketingAreaData,
        isLive,
        network,
        zipCode,
      };
      await getContentBlackout(blackoutOptions);
      console.debug('content blackout not available', zipCode);
    } catch (error) {
      if (isBlackoutError(error)) {
        console.debug('content blackout active');
        const contentBlackoutLanguageOverrides = _.get(error, 'contentBlackoutLanguageOverrides');
        setAuthError(true);
        this.setState({
          showContentBlackout: true,
          contentBlackoutLanguageOverrides,
        });
      } else {
        console.debug('content blackout error', error);
      }
    }
  };

  handleExpiration = ({ type }) => {
    const {
      videoId,
      showEndcards,
      isLive,
      playerReference,
      provider,
      account,
      setProvider,
      requiresAuth,
    } = this.props;
    const mvpdId = _.get(provider, 'adobePassId');
    const setStateCallback = () => {
      const profileId = _.get(account, 'profileId');
      const previewPassEvents = getPreviewPassAnalyticsEvents({
        previewPassLength: getPreviewPassLengthFromName(mvpdId),
        profileId,
      });
      const onPreviewPassExpired = _.get(
        previewPassEvents,
        GeneralTrackEvents.PREVIEW_PASS_EXPIRED,
        _.noop,
      );
      onPreviewPassExpired();

      const previewPassLength = mvpdId === PREVIEW_PASS_60 ? 60 : 5;
      getSegmentMVPDEvents().mvpdPreviewPassExpired({
        page_preview_pass_length: previewPassLength,
      });

      if (!isLive) {
        showEndcards(false);
      }
      setProvider(null);
      if (requiresAuth) {
        playerRemove(playerReference);
      } else {
        playerPause(playerReference);
      }
    };

    if (type === 'MVPD') {
      this.previewPassLogout();
      const disableDuplicateOverlay = _.get(
        getOptimizelyRedesignExperiments(),
        'disableDuplicateOverlay',
        false,
      );

      const { videoId, resumeOnCancel, onAuthCheckComplete } = this.props;
      resumeOnCancel();

      const newState = {
        activeVideo: videoId,
        mvpdExpired: true,
        percentWatched: this.getPercentWatched(),
        showProviders: true,
        showSignIn: !disableDuplicateOverlay,
      };
      const newStateCallback = () => {
        onAuthCheckComplete({ complete: false, success: false });
        this.setState({ showSignIn: true });
      };

      this.setState(newState, newStateCallback);
      if (!isLive) {
        showEndcards(false);
      }
      setProvider(null);
      if (requiresAuth) {
        playerRemove(playerReference);
      } else {
        playerPause(playerReference);
      }
    } else {
      this.previewPassLogout();
      this.setState(
        {
          previewPassExpired: true,
          percentWatched: this.getPercentWatched(),
          activeVideo: videoId,
        },
        setStateCallback,
      );
    }
  };

  handleHover = hover => {
    const { setStickyControls, setPlayerDataHover } = this.props;
    setStickyControls(hover);
    setPlayerDataHover(hover);
  };

  handlePPBannerClick = () => {
    const { onAuthCheckComplete, playerReference } = this.props;
    const playerState = getPlayerState(playerReference);
    const validStates = [PLAYER_STATES.PLAYING, PLAYER_STATES.AD, PLAYER_STATES.BUFFERING];
    if (_.indexOf(validStates, playerState) >= 0) {
      playerPause(playerReference);
    }

    const disableDuplicateOverlay = _.get(
      getOptimizelyRedesignExperiments(),
      'disableDuplicateOverlay',
      false,
    );

    const { videoId, resumeOnCancel } = this.props;
    resumeOnCancel();

    const newState = {
      showProviders: true,
      previewPassSignIn: true,
      percentWatched: this.getPercentWatched(),
      activeVideo: videoId,
      playerState,
      showSignIn: !disableDuplicateOverlay,
    };

    const newStateCallback = () => {
      onAuthCheckComplete({ complete: false, success: false });
      this.setState({ showSignIn: true });
    };

    this.setState(newState, newStateCallback);
  };

  resetShowCookiesBlocked = () => {
    this.setState({ showCookiesBlocked: false });
  };

  renderAuth() {
    const {
      authorizingNetwork,
      background,
      callSign,
      contentNetworks,
      contentRating,
      contentSKU,
      entitlementIssues,
      geoLocationDeclined,
      geoLocationPrimaryActionCallback,
      geoLocationTimeoutFail,
      guid,
      isLive,
      isLiveRestart,
      network,
      releaseURL,
      renderAuthContainer,
      requestSignIn,
      requiresAuth,
      requiresAuthLive,
      resumeWithProfileConfig,
      savePercentWatched,
      selectedChannel,
      setAuthError,
      setPreAuthCheckComplete,
      setVideoOverlay,
      shouldCheckPreviewPass,
      showNoSportsOnMobileError,
      showResumeCTA,
      subscriptionPaused,
      triggerAuthCheck,
      type,
      videoId,
      videoType,
    } = this.props;
    const {
      mvpdExpired,
      previewPassExpired,
      previewPassSignIn,
      showBuythroughUpsell,
      showContentBlackout,
      showCookiesBlocked,
      showProviders,
      showSignIn,
    } = this.state;
    const waitForVideo = !videoId && !releaseURL;
    const waitForUpsell = showBuythroughUpsell;
    const channel = getChannelId({ network, authorizingNetwork });
    const playerRelatedAuthProps = {
      authorizingNetwork,
      background,
      callSign,
      channel,
      checkBlackouts: true,
      checkBuythroughScenarios: false,
      contentBlackoutActive: showContentBlackout,
      contentNetworks,
      contentRating,
      contentSKU,
      entitlementIssues,
      geoLocationDeclined,
      geoLocationPrimaryActionCallback,
      geoLocationTimeoutFail,
      getDesignatedMarketingAreaData,
      guid,
      isLive,
      isLiveRestart,
      mvpdExpired,
      network,
      onShowProvidersCallback: this.onShowProvidersCallback,
      previewPassExpired,
      previewPassSignIn,
      releaseURL,
      requestSignIn,
      requiresAuth,
      requiresAuthLive,
      resetShowCookiesBlocked: this.resetShowCookiesBlocked,
      resumeWithProfileConfig,
      savePercentWatched,
      selectedChannel,
      setAuthError,
      setDelayPlayback: this.setDelayPlayback,
      setPreAuthCheckComplete,
      setToken: this.setToken,
      setVideoOverlay,
      shouldCheckPreviewPass,
      showCookiesBlocked,
      showNoSportsOnMobileError,
      showProviders,
      showResumeCTA,
      showSignIn,
      subscriptionPaused,
      triggerAuthCheck,
      type,
      videoId,
      videoType,
      waitForUpsell,
      waitForVideo,
    };

    return renderAuthContainer(playerRelatedAuthProps);
  }

  renderContextualRoadBlock = () => {
    const { showBuythroughUpsell, isTrailerUpsell } = this.state;
    const {
      roadBlockbackground,
      nextVideoPath,
      breakpoint,
      account,
      subscriptionPaused,
    } = this.props;
    if (!showBuythroughUpsell) return null;

    return (
      <ContextualRoadBlock
        account={account}
        subscriptionPaused={subscriptionPaused}
        isTrailerUpsell={isTrailerUpsell}
        backgroundImage={roadBlockbackground}
        isTablet={isTabletBreakpoint(breakpoint)}
        isMobile={isMobileBreakpoint(breakpoint)}
        pathOverride={nextVideoPath}
      />
    );
  };

  renderBuythroughUpsellMessage = () => {
    const { isTrailerUpsell, showBuythroughUpsell, showEmailCapture } = this.state;
    const { account, subscriptionPaused } = this.props;
    if (!showBuythroughUpsell || showEmailCapture) return null;
    const {
      playback_upsellBlockHeader: headerText,
      playback_upsellBlockHeaderMobile: headerMobileText,
      playback_upsellBlockMessageMobile: messageTextMobile,
    } = window.Language;
    const messageProps = {
      account,
      header: headerMobileText || headerText,
      isTrailerUpsell,
      messageText: messageTextMobile,
      subscriptionPaused,
      theme: MessageStyle,
    };
    return <Message {...messageProps} />;
  };

  renderOnHoldAccount = () => {
    const { isAccountOnHold } = this.state;
    if (!isAccountOnHold) return null;
    const { profile_googleAccountOnHold: googleOnHoldMessage } = window.Language;
    return <OnHoldAccount message={googleOnHoldMessage} />;
  };

  renderRokuOnHoldAccount = () => {
    const { isRokuOnHold } = this.state;
    if (!isRokuOnHold) return null;
    const { roku_on_hold_text: rokuOnHoldMessage } = window.Language;
    return <OnHoldAccount message={rokuOnHoldMessage} />;
  };

  renderOnPauseAccount = () => {
    const { isSubscriptionPaused } = this.state;
    if (!isSubscriptionPaused) return null;
    return <OnPauseAccount />;
  };

  renderContentBlackout = () => {
    const { background, channel } = this.props;
    const { contentBlackoutLanguageOverrides, showContentBlackout } = this.state;
    const backgroundUrl = background || getChannelBackgroundUrl(channel);
    const titleId = _.get(contentBlackoutLanguageOverrides, 'title');
    const messageId = _.get(contentBlackoutLanguageOverrides, 'message');
    const defaultTitle = _.get(window.Language, 'blackout_default_title');
    const defaultMessage = _.get(window.Language, 'blackout_default');
    const title = _.get(window.Language, titleId, defaultTitle);
    const message = _.get(window.Language, messageId, defaultMessage);

    if (!showContentBlackout) return null;

    return <ContentBlackout background={backgroundUrl} title={title} message={message} />;
  };

  renderExpiredVOD = () => {
    const { background, channel } = this.props;
    const { showExpiredVOD } = this.state;
    const backgroundUrl = background || getChannelBackgroundUrl(channel);
    const title = _.get(window.Language, 'playback_expiredContentHeader');
    const message = _.get(window.Language, 'playback_expiredContentMessage');

    if (!showExpiredVOD) return null;

    return <ExpiredVod background={backgroundUrl} title={title} message={message} />;
  };

  renderPlayerLoadingImage() {
    const { breakpoint, channel, playerLoading, mode, theme } = this.props;
    const { playerLoadingImage, showBuythroughUpsell } = this.state;
    const backgroundUrl = playerLoadingImage || getChannelBackgroundUrl(channel);
    const imageTag = renderImage({
      breakpoint,
      className: theme.playerLoadingImage,
      imageType: LIVE_PLAYER_BACKGROUND_IMAGE,
      src: backgroundUrl,
    });

    if (!playerLoading || mode === LIVE || showBuythroughUpsell) return null;

    return imageTag;
  }

  setMVPDExpiration = mvpdTTL => {
    const {
      displayPrimeTimeMessage,
      isVideoBanner,
      playerLoading,
      provider,
      reducerVideo,
      requestSignIn,
    } = this.props;

    const mvpdId = _.get(provider, 'adobePassId');
    const requiresAuth = _.get(reducerVideo, 'requiresAuth', false);
    const requiresAuthLive = _.get(reducerVideo, 'requiresAuthLive', false);
    const cookie = getMVPDCookie();
    if (
      !cookie ||
      (!requiresAuth && !requiresAuthLive) ||
      isPreviewPass(mvpdId) ||
      displayPrimeTimeMessage ||
      (playerLoading && !requestSignIn) ||
      isVideoBanner
    ) {
      return null;
    }

    return <MVPDTimer unixEndTime={mvpdTTL} expirationCallback={this.handleExpiration} />;
  };

  renderPreviewPassBanner = previewPassTTL => {
    const {
      authorizingNetwork,
      disablePreviewPassRender,
      displayPrimeTimeMessage,
      isFullscreen,
      isVideoBanner,
      mode,
      panelVideo,
      playerLoading,
      provider,
      requestSignIn,
      reducerVideo,
      theme,
    } = this.props;
    const { previewPassExpired } = this.state;
    const mvpdId = _.get(provider, 'adobePassId');
    const ppDate = previewPassTTL ? msToDate(previewPassTTL) : null;
    const validTTL = ppDate ? differenceInSeconds(ppDate, now()) > 0 : false;
    const isVOD = mode === VOD;
    const isNationLiveAndNotFNC = mode === LIVE && authorizingNetwork !== FNC;
    const {
      preveiwPass_banner_start: bannerStartText,
      preveiwPass_banner_end: bannerEndText,
      preveiwPass_banner_link: bannerLinkText,
    } = window.Language;
    const requiresAuth =
      _.get(reducerVideo, 'requiresAuth', false) || _.get(panelVideo, 'requiresAuth', false);
    const requiresAuthLive =
      _.get(reducerVideo, 'requiresAuthLive', false) ||
      _.get(panelVideo, 'requiresAuthLive', false);

    if (
      (!requiresAuth && !requiresAuthLive) ||
      !previewPassEnabled() ||
      !isPreviewPass(mvpdId) ||
      displayPrimeTimeMessage ||
      (playerLoading && !requestSignIn) ||
      !validTTL ||
      previewPassExpired ||
      disablePreviewPassRender ||
      isVOD ||
      isNationLiveAndNotFNC ||
      isVideoBanner
    ) {
      return null;
    }
    const { showControls } = this.props;

    const previewPassHoverEnabled = _.get(
      getOptimizelyPreviewPassExperiments(),
      'previewPassHoverActive',
      false,
    );
    const previewPassTransition =
      showControls && !requestSignIn && previewPassHoverEnabled && theme.previewPassTransition;
    const previewPassCopyClasses = classNames([
      previewPassHoverEnabled && theme.previewPassCopyWithHover,
      theme.previewPassCopy,
    ]);
    const previewPassClasses = classNames([
      theme.previewPass,
      Style.previewPassBanner,
      previewPassHoverEnabled && theme.previewPassWithHover,
      isFullscreen && theme.previewPassHideFullscreen,
    ]);
    const previewPassLoginLinkClasses = classNames([
      theme.previewPassLoginLink,
      previewPassHoverEnabled && theme.previewPassLoginLinkWithHover,
    ]);
    return (
      <div
        id="preview-pass-banner"
        className={classNames([previewPassClasses, previewPassTransition])}
        onMouseEnter={() => {
          this.handleHover(true);
        }}
      >
        <div className={previewPassCopyClasses}>
          <div className={theme.previewPassText}>
            <span>{bannerStartText}</span>
            <Timer
              unixEndTime={previewPassTTL}
              expirationCallback={() => this.handleExpiration({ type: 'PREVIEW_PASS' })}
            />
            <span>{bannerEndText}</span>
          </div>
          <span className={previewPassLoginLinkClasses}>
            <Link onClick={this.handlePPBannerClick}>{bannerLinkText}</Link>
            <span className={theme.previewPassLine} />
          </span>
        </div>
      </div>
    );
  };

  renderStillWatching() {
    const { background, channel, showStillWatching, onStillWatchingClose, account } = this.props;
    const backgroundUrl = background || getChannelBackgroundUrl(channel);
    const profileId = _.get(account, 'profileId');

    if (!showStillWatching) return null;

    return (
      <AreYouWatching
        onClose={() => {
          const {
            [GeneralTrackEvents.PLAYER_IDLE_PROMPT_CONFIRM]: onPlayerIdlePromptConfirm,
          } = getTealiumPlayerEvents({ profileId });
          onPlayerIdlePromptConfirm();
          onStillWatchingClose();
          handleAnalytics({
            event: Events.IDLE_PROMPT_ACTION,
            payload: { page_action_type: 'Yes, continue watching' },
          });
        }}
        background={backgroundUrl}
      />
    );
  }

  renderEmailCapture() {
    const { emailCaptureInput, isEmailCaptureValid, showEmailCapture } = this.state;
    const { account, background, channel, preauthorizedResources, mediaInfo } = this.props;
    const entitlementList = preauthorizedResources || [];
    entitlementList.sort(sortEntitlements);
    const networkEntitlementList = entitlementList.join(',');
    const title = mediaInfo?.seriesName;
    const subtitle = mediaInfo?.name;
    const backgroundUrl = background || getChannelBackgroundUrl(channel);
    const isSignedIn = account || isMvpdSubscription();
    const isEmailCaptureEnabled = getEmailCaptureCookie() || !emailCaptureEnabled();

    if (isSignedIn || !showEmailCapture || isEmailCaptureEnabled) return null;

    return (
      <EmailCapture
        background={backgroundUrl}
        emailCaptureInput={emailCaptureInput}
        entitlements={networkEntitlementList}
        isValid={isEmailCaptureValid}
        onChange={this.onEmailCaptureChange}
        onSubmit={this.onEmailCaptureSubmit}
        title={title}
        subtitle={subtitle}
      />
    );
  }

  render() {
    const {
      account,
      adblock,
      anonymousId,
      authSuccess,
      authorizingNetwork,
      backfade,
      background,
      breakpoint,
      channel,
      children,
      containerClass,
      containerId,
      displayPrimeTimeMessage,
      endCards,
      hideLoadingText,
      isFullscreen,
      isNationDigitalChannel,
      isStatic,
      isVideoBanner,
      liveContentId,
      liveNow,
      mediaInfo,
      mute,
      mode,
      network,
      playerConfig,
      playerLoading,
      playerReference,
      playerType,
      portalRef,
      preauthorizedResources,
      primeTimeMessage,
      primetimeScrollTo,
      profileId,
      profileToken,
      provider,
      releaseURL,
      requestSignIn,
      requiresAuth,
      requiresAuthLive,
      scrubbingEnabled,
      selectedVideo,
      showControls,
      showResumeCTA,
      showUpNextToast,
      siteSection,
      theme,
      type,
      videoDetail,
      videoId,
      waitToRenderPlayer,
    } = this.props;
    const profileAnonymous = !account;
    const mvpdId = _.get(provider, 'adobePassId');
    const {
      activeVideo,
      delayPlayback,
      percentWatched,
      previewPassExpired,
      showBuythroughUpsell,
      spoofedGeolation,
    } = this.state;
    const abTest = getOptimizelyPlayerExperiments();
    // update releaseURL based off the debug panel.
    let playerConfigParams = {};

    const adDebug = getAdDebug();
    const adSiteSection = getAdSiteSection();
    const privacyParameter = getPrivacyParameterCookie();

    if (adDebug || adSiteSection || privacyParameter) {
      playerConfigParams = {
        params: {
          ads: {
            siteSection: adSiteSection,
            debugParameter: adDebug,
            privacyParameter,
          },
        },
      };
    }

    if (percentWatched && activeVideo === videoId) {
      playerConfigParams = {
        ...playerConfigParams,
        ...{ percentWatched, activeVideo, mvpdId },
      };
    }
    // if (!account) {
    //   playerConfigParams = {
    //     ...playerConfigParams,
    //     ...{ percentWatched: 0 },
    //   };
    // }
    const mvpd = getMVPDFromCookie();
    const mvpdRights = _.get(window.ExternalConfig, `contentRights.${mvpd}`);
    const mvpdRightsNetwork = _.get(mvpdRights, 'network');
    const zipcode = mvpdRightsNetwork === network ? _.get(mvpdRights, 'zipcode') : null;
    const pcpParams = _.get(playerConfigParams, 'params', {});

    playerConfigParams = {
      ...playerConfigParams,
      params: {
        ...pcpParams,
        abTest,
        page_test_name: (getSegmentOptimizelyString && getSegmentOptimizelyString()) || null,
        zipcode,
      },
    };

    _.set(playerConfigParams, 'params.ads.publisherId', anonymousId);

    const entitlementList = preauthorizedResources || [];
    entitlementList.sort(sortEntitlements);
    const networkEntitlementList = entitlementList.join(',');
    const newPlayerConfig = {
      ...playerConfig,
      ...playerConfigParams,
      authorizingNetwork,
      networkEntitlementList,
      mute,
      container: containerId,
    };

    const backgroundUrl = background || getChannelBackgroundUrl(channel);
    const previewPassTTL = getPreviewPassTime();
    const mvpdTTL = getMVPDExpireTime();

    if (adblock) {
      return (
        <div className={theme.container}>
          <AdBlock background={backgroundUrl} />
        </div>
      );
    }

    const { showProviders, token, upstreamUserID, hbaStatus } = this.state;

    const containerClasses = classNames(
      isFullscreen ? theme.fullscreen : false,
      previewPassExpired ? theme.previewPassExpired : false,
      theme.container,
      containerClass,
      showProviders || showUpNextToast ? theme.hideControls : false,
      theme.redesignCollections,
      endCards ? theme.containsEndCards : false,
      isVideoBanner ? theme.videoBannerContainer : false,
      isNationDigitalChannel ? theme.nationDigitalVideoPlayerContainer : false,
      isEpgv2Enabled() ? theme.resizablePlayer : false,
    );
    const backfadeClasses = classNames(
      theme.backfade,
      backfade && showControls ? theme.backfadeVisible : null,
    );
    const { showLoader } = BREAKPOINTS[breakpoint];
    const loader = playerLoading && showLoader && <Loader className={theme.loader} />;
    const {
      livePlayer_preprimetimeButton: preprimetimeButtonText,
      livePlayer_preprimetimeText: preprimetimeText,
      livePlayer_loadingText: loadingText,
    } = window.Language;
    const loaderBackgroundStyle = {
      backgroundImage: backgroundUrl ? `url('${backgroundUrl}')` : null,
    };
    let channelLoaderComponent = null;

    if (displayPrimeTimeMessage) {
      channelLoaderComponent = (
        <span
          className={classNames(theme.noVideoBackground, theme.loaderBackground)}
          style={loaderBackgroundStyle}
        >
          <div className={theme.preprimetimeText}>{primeTimeMessage || preprimetimeText}</div>
          <ScrollLink className={theme.preprimetimeButton} to={primetimeScrollTo} smooth>
            {preprimetimeButtonText}
          </ScrollLink>
        </span>
      );
    } else if (selectedVideo && playerLoading && !showBuythroughUpsell) {
      channelLoaderComponent = (
        <span className={theme.loaderBackground} style={loaderBackgroundStyle}>
          {!hideLoadingText && <div className={theme.loaderText}>{loadingText}</div>}
          {loader}
        </span>
      );
    }

    const loaderComponent = (channel && channelLoaderComponent) || loader;

    const delayedReleaseURL = !authSuccess || delayPlayback ? null : releaseURL;
    let player = null;
    const isTveEnabled = tveEnabled();
    const lastAnonymousProfileId = getSegmentLastAnonymousProfileId();
    const lastKnownProfileId = getSegmentLastKnownProfileId();
    if (!waitToRenderPlayer && !isStatic) {
      player = (
        <VideoPlayer
          geolocation={spoofedGeolation || getLocationCookies()}
          hbaStatus={hbaStatus}
          isFullscreen={isFullscreen}
          lastAnonymousProfileId={lastAnonymousProfileId}
          lastKnownProfileId={lastKnownProfileId}
          liveContentId={liveContentId}
          loadPlayerCb={this.setIsPlayerLoaded}
          mediaInfo={mediaInfo}
          mode={mode}
          mvpdId={mvpdId}
          playerConfig={newPlayerConfig}
          playerJs={getPlayerJs()}
          playerLoadingImage={background}
          playerReference={playerReference}
          playerType={playerType}
          portalRef={portalRef}
          profileAnonymous={profileAnonymous}
          profileId={profileId}
          profileToken={profileToken}
          releaseURL={delayedReleaseURL}
          requestSignIn={requestSignIn}
          requiresAuth={requiresAuth}
          requiresAuthLive={requiresAuthLive}
          scrubbingEnabled={scrubbingEnabled}
          showResumeCTA={showResumeCTA}
          token={token}
          tveEnabled={isTveEnabled}
          type={type}
          upstreamUserID={upstreamUserID}
          videoId={videoId}
        />
      );

      if (!waitToRenderPlayer && children) {
        player = React.Children.map(children, child =>
          React.cloneElement(child, {
            authSuccess,
            externalId: 'dfwvideoplayer',
            geolocation: spoofedGeolation || getLocationCookies(),
            hbaStatus,
            isFullscreen,
            releaseURL: delayedReleaseURL,
            videoId,
            liveContentId,
            lastAnonymousProfileId,
            lastKnownProfileId,
            token,
            upstreamUserID,
            mvpdId,
            playerJs: getPlayerJs(),
            playerReference,
            playerType,
            requiresAuth,
            requiresAuthLive,
            siteSection,
            type,
            mode,
            liveNow,
            profileAnonymous,
            profileId,
            profileToken,
            playerConfig: newPlayerConfig,
            portalRef,
            mediaInfo,
            playerLoadingImage: background,
            scrubbingEnabled,
            loadPlayerCb: this.setIsPlayerLoaded,
            requestSignIn,
            showResumeCTA,
            tveEnabled: isTveEnabled,
          }),
        );
      }
    }

    return (
      <>
        <div
          role="region"
          className={containerClasses}
          onMouseEnter={() => {
            this.handleHover(true);
          }}
          onMouseLeave={() => {
            this.handleHover(false);
          }}
        >
          {this.renderAuth()}
          {this.renderContentBlackout()}
          {this.renderContextualRoadBlock()}
          {this.renderEmailCapture()}
          {this.renderExpiredVOD()}
          {this.renderOnHoldAccount()}
          {this.renderRokuOnHoldAccount()}
          {this.renderOnPauseAccount()}
          {this.renderPlayerLoadingImage()}
          {this.renderPreviewPassBanner(previewPassTTL)}
          {this.renderStillWatching()}
          {this.setMVPDExpiration(mvpdTTL)}
          {player}
          {<div className={backfadeClasses} />}
          {loaderComponent}
          {endCards}
        </div>
        {this.renderBuythroughUpsellMessage()}
        {videoDetail}
      </>
    );
  }
}

VideoContainer.defaultProps = {
  accessToken: '',
  account: null,
  anonymousAccount: null,
  adblock: false,
  anonymousId: null,
  authorizingNetwork: null,
  authSuccess: false,
  background: '',
  blackoutConfig: {},
  blackoutDefinitions: {},
  breakpoint: null,
  callSign: null,
  channel: null,
  children: null,
  containerClass: null,
  containerId: null,
  contentNetworks: [],
  contentRating: null,
  contentSKU: null,
  deviceId: null,
  disablePreviewPassRender: false,
  displayPrimeTimeMessage: null,
  dma: null,
  endCards: null,
  entitlementIssues: null,
  geoLocationDeclined: null,
  geoLocationPrimaryActionCallback: noop,
  geoLocationTimeoutFail: false,
  guid: null,
  hideLoadingText: false,
  isFreemium: false,
  isFullscreen: false,
  isLive: false,
  isLiveRestart: false,
  isNationDigitalChannel: false,
  isStatic: false,
  isUngatedVideo: false,
  isVideoBanner: false,
  isVodUnavailable: false,
  liveContentId: null,
  liveNow: false,
  mediaInfo: null,
  mode: null,
  mute: false,
  mvpd: null,
  network: null,
  nextVideoPath: null,
  onAuthCheckComplete: noop,
  playerReference: PLAYER_REFERENCE_DEFAULT,
  playerType: '',
  portalRef: '',
  preauthorizedResources: [],
  primeTimeMessage: null,
  primetimeScrollTo: null,
  profileId: null,
  profileToken: null,
  provider: null,
  reducerVideo: {},
  releaseURL: null,
  requestSignIn: false,
  requiresAuth: null,
  requiresAuthLive: null,
  resumeOnCancel: noop,
  resumeWithProfileConfig: null,
  retryErrors: {},
  roadBlockbackground: '',
  savePercentWatched: noop,
  scrubbingEnabled: null,
  selectedChannel: null,
  selectedVideo: null,
  setAuthError: noop,
  setBlockMVPDIncomplete: noop,
  setIsPlayerLoaded: noop,
  setPlayerDataHover: noop,
  setPreAuthCheckComplete: noop,
  setProvider: noop,
  setStickyControls: noop,
  setVideoOverlay: noop,
  shouldCheckPreviewPass: true,
  showControls: false,
  showEndcards: noop,
  showNoSportsOnMobileError: false,
  showResumeCTA: false,
  showTrailerUpsell: false,
  showUpNextToast: false,
  siteSection: null,
  subscriptionPaused: false,
  subscription: null,
  theme: {},
  triggerAuthCheck: false,
  videoDetail: null,
  videoId: null,
  videoType: null,
  waitToRenderPlayer: false,
};

VideoContainer.propTypes = {
  accessToken: PropTypes.string,
  account: PropTypes.shape({}),
  anonymousAccount: PropTypes.shape({}),
  adblock: PropTypes.bool,
  anonymousId: PropTypes.string,
  authorizingNetwork: PropTypes.string,
  auth: PropTypes.shape({}),
  authSuccess: PropTypes.bool,
  backfade: PropTypes.bool.isRequired,
  background: PropTypes.string,
  blackoutConfig: PropTypes.shape({}),
  blackoutDefinitions: PropTypes.shape({}),
  breakpoint: PropTypes.string,
  callSign: PropTypes.string,
  channel: PropTypes.string,
  children: PropTypes.node,
  containerClass: PropTypes.string,
  containerId: PropTypes.string,
  contentNetworks: PropTypes.arrayOf(PropTypes.string),
  contentRating: PropTypes.string,
  contentSKU: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
  deviceId: PropTypes.string,
  disablePreviewPassRender: PropTypes.bool,
  displayPrimeTimeMessage: PropTypes.string,
  dma: PropTypes.string,
  endCards: PropTypes.node,
  entitlementIssues: PropTypes.arrayOf(PropTypes.shape({})),
  geoLocationDeclined: PropTypes.bool,
  geoLocationPrimaryActionCallback: PropTypes.func,
  geoLocationTimeoutFail: PropTypes.bool,
  guid: PropTypes.string,
  hideLoadingText: PropTypes.bool,
  isFreemium: PropTypes.bool,
  isFullscreen: PropTypes.bool,
  isLive: PropTypes.bool,
  isLiveRestart: PropTypes.bool,
  isNationDigitalChannel: PropTypes.bool,
  isStatic: PropTypes.bool,
  isUngatedVideo: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isVideoBanner: PropTypes.bool,
  isVodUnavailable: PropTypes.bool,
  liveContentId: PropTypes.string,
  liveNow: PropTypes.bool,
  mediaInfo: PropTypes.shape({}),
  mode: PropTypes.string,
  mute: PropTypes.bool,
  mvpd: PropTypes.shape({}),
  network: PropTypes.string,
  nextVideoPath: PropTypes.string,
  onAuthCheckComplete: PropTypes.func,
  onStillWatchingClose: PropTypes.func.isRequired,
  panelVideo: PropTypes.shape({}),
  playerConfig: PropTypes.shape({}).isRequired,
  playerLoading: PropTypes.bool.isRequired,
  playerReference: PropTypes.string,
  playerType: PropTypes.string,
  portalRef: PropTypes.string,
  preauthorizedResources: PropTypes.arrayOf(PropTypes.string),
  primeTimeMessage: PropTypes.string,
  primetimeScrollTo: PropTypes.string,
  profileId: PropTypes.string,
  profileToken: PropTypes.string,
  provider: PropTypes.shape({}),
  reducerVideo: PropTypes.shape({}),
  releaseURL: PropTypes.string,
  renderAuthContainer: PropTypes.func.isRequired,
  requestSignIn: PropTypes.bool,
  requiresAuth: PropTypes.bool,
  requiresAuthLive: PropTypes.bool,
  resumeOnCancel: PropTypes.func,
  resumeWithProfileConfig: PropTypes.shape(),
  retryErrors: PropTypes.shape({}),
  roadBlockbackground: PropTypes.string,
  savePercentWatched: PropTypes.func,
  scrubbingEnabled: PropTypes.bool,
  selectedChannel: PropTypes.number,
  selectedVideo: PropTypes.string,
  setAuthError: PropTypes.func,
  setBlockMVPDIncomplete: PropTypes.func,
  setIsPlayerLoaded: PropTypes.func,
  setPlayerDataHover: PropTypes.func,
  setPreAuthCheckComplete: PropTypes.func,
  setProvider: PropTypes.func,
  setStickyControls: PropTypes.func,
  setVideoOverlay: PropTypes.func,
  shouldCheckPreviewPass: PropTypes.bool,
  showControls: PropTypes.bool,
  showEndcards: PropTypes.func,
  showNoSportsOnMobileError: PropTypes.bool,
  showResumeCTA: PropTypes.bool,
  showStillWatching: PropTypes.bool.isRequired,
  showTrailerUpsell: PropTypes.bool,
  showUpNextToast: PropTypes.bool,
  siteSection: PropTypes.string,
  subscriptionPaused: PropTypes.bool,
  subscription: PropTypes.shape({}),
  theme: PropTypes.shape({}),
  toggleMvpdAuthOverlay: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  triggerAuthCheck: PropTypes.bool,
  type: PropTypes.string.isRequired,
  videoDetail: PropTypes.shape({}),
  videoId: PropTypes.string,
  videoType: PropTypes.string,
  waitToRenderPlayer: PropTypes.bool,
};

export default withAuth(VideoContainer);
